import { Routes } from '@angular/router';
import { authGuard } from 'app/guards/auth.guard';

export const routes: Routes = [

    // Learn routes
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('app/layouts/app-layout/app-layout.component').then(c => c.AppLayoutComponent),
        children: [
            {
                path: '',
                //redirectTo: 'practice',
                redirectTo: 'learn',
                pathMatch: 'full'
            },
            {
                path: 'learn',
                children: [
                    {
                        path: '',
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/learn/learn.component').then(c => c.LearnComponent)
                            }
                        ]
                    },
                ],
            },
            {
                path: 'practice',
                loadComponent: () => import('app/modules/practice/practice-router/practice-router.component').then(c => c.PracticeRouterComponent),
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/modules/practice/practice.component').then(c => c.PracticeComponent),
                    },
                    {
                        path: 'roleplaying',
                        loadComponent: () => import('app/modules/roleplaying/roleplaying-router/roleplaying-router.component').then(c => c.RoleplayingRouterComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/roleplaying/roleplaying.component').then(c => c.RoleplayingComponent),
                            },
                            {
                                path: 'preview',
                                loadComponent: () => import('app/modules/generic-roleplaying/preview/preview.component').then(c => c.GenericRoleplayingPreviewComponent)
                            },
                        ]
                    },
                    {
                        path: 'picture-description',
                        loadComponent: () => import('app/modules/picture-description/picture-description-router/picture-description-router.component').then(c => c.PictureDescriptionRouterComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/picture-description/picture-description.component').then(c => c.PictureDescriptionComponent),
                            },
                            {
                                path: 'viewer',
                                loadComponent: () => import('app/modules/picture-description/picture-description-viewer/picture-description-viewer.component').then(c => c.PictureDescriptionViewerComponent),
                            },
                            {
                                path: 'rewards',
                                loadComponent: () => import('app/modules/picture-description/picture-description-rewards/picture-description-rewards.component').then(c => c.PictureDescriptionRewardsComponent),
                            }
                        ]
                    },
                    {
                        path: 'custom-conversation',
                        loadComponent: () => import('app/modules/custom-conversation/custom-conversation.component').then(c => c.CustomConversationComponent)
                    },
                    {
                        path: 'character',
                        loadComponent: () => import('app/modules/character/character-router/character-router.component').then(c => c.CharacterRouterComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/character/character.component').then(c => c.CharacterComponent)
                            },
                            {
                                path: 'preview',
                                loadComponent: () => import('app/modules/generic-roleplaying/preview/preview.component').then(c => c.GenericRoleplayingPreviewComponent)
                            }
                        ]
                    }
                ]
            },
            {
                path: 'profile',
                loadComponent: () => import('app/modules/profile/profile.component').then(c => c.ProfileComponent)
            },
            {
                path: 'dictionary',
                loadComponent: () => import('app/modules/dictionary/dictionary.component').then(c => c.DictionaryComponent)
            },
            {
                path: 'learn-routes',
                loadComponent: () => import('app/modules/learn/learn-routes/learn-routes.component').then(c => c.LearnRoutesComponent)
            },
        ]
    },

    // Subscription

    {
        path: 'subscription',
        canActivate: [authGuard],
        loadComponent: () => import('./layouts/subscription-layout/subscription-layout.component').then(c => c.SubscriptionLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('app/modules/subscription/subscription.component').then(c => c.SubscriptionComponent)
            },
            {
                path: 'payment-gateway',
                loadComponent: () => import('app/modules/subscription/payment-gateway/payment-gateway.component').then(c => c.PaymentGatewayComponent)
            },
            {
                path: 'details',
                loadComponent: () => import('app/modules/subscription/subscription-details/subscription-details.component').then(c => c.SubscriptionDetailsComponent)
            }
        ]
    },

    // Initial evaluation
    {
        path: 'learn/initial-evaluation',
        canActivate: [authGuard],
        loadComponent: () => import('app/layouts/chat-layout/chat-layout.component').then(c => c.ChatLayoutComponent),
        children:[
            {
                path: '',
                loadComponent: () => import('app/modules/learn/initial-evaluation/initial-evaluation.component').then(c => c.InitialEvaluationComponent)
            }
        ]
    },


    // learn

    {
        path: 'learn/lesson',
        canActivate: [authGuard],
        loadComponent: () => import('app/layouts/chat-layout/chat-layout.component').then(c => c.ChatLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('app/modules/learn/lesson/lesson.component').then(c => c.LessonComponent)
            }
        ]
    },

    // School
    {
        path: 'school',
        canActivate: [authGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('app/layouts/app-layout/app-layout.component').then(c => c.AppLayoutComponent),
                canActivate: [authGuard],
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/modules/school/school.component').then(c => c.SchoolComponent)
                    }
                ]
            },
            {
                path: 'wizard',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/wizard/wizard.component').then(c => c.WizardComponent)
                            }
                        ]
                    }
                ]
            },
            {
                path: 'dashboard',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/dashboard/dashboard.component').then(c => c.DashboardComponent)
                            }
                        ]
                    }
                ]
            },
            {
                path: 'student-dashboard',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/app-layout/app-layout.component').then(c => c.AppLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/student-dashboard/student-dashboard.component').then(c => c.StudentDashboardComponent)
                            },
                            {
                                path: 'custom-chat',
                                loadComponent: () => import('app/modules/school/student-dashboard/custom-chat/custom-chat.component').then(c => c.CustomChatComponent)
                            }
                        ]
                    }
                ]
            },
            {
                path: 'collaborator',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/collaborator/collaborator.component').then(c => c.CollaboratorComponent)
                            }
                        ]
                    },
                    {
                        path: 'create',
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                                children: [
                                    {
                                        path: '',
                                        loadComponent: () => import('app/modules/school/collaborator/collaborator-wizard/collaborator-wizard.component').then(c => c.CollaboratorWizardComponent)
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            // Classroom
            {
                path: 'classroom',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/classroom/classroom.component').then(c => c.ClassroomComponent)
                            }
                        ]
                    },
                    {
                        path: 'create',
                        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/classroom/classroom-wizard/classroom-wizard.component').then(c => c.ClassroomWizardComponent)
                            }
                        ]
                    },
                    {
                        path: 'edit',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                // loadComponent: () => import('app/modules/school/classroom/classroom-form/classroom-form.component').then(c => c.ClassroomFormComponent)
                                loadComponent: () => import('app/modules/school/classroom/classroom-viewer/classroom-viewer.component').then(c => c.ClassroomViewerComponent)
                            }
                        ]
                    },
                    {
                        path: 'schedule',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/classroom/classroom-viewer/classroom-schedule/classroom-schedule.component').then(c => c.ClassroomScheduleComponent)
                            }
                        ]
                    }
                ]
            },
            // Homework
            {
                path: 'homework',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/homework/homework.component').then(c => c.HomeworkComponent)
                            }
                        ]
                    },
                    {
                        path: 'viewer',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/homework/viewer/viewer.component').then(c => c.ViewerComponent)
                            }
                        ]
                    },
                    {
                        path: 'create',
                        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/homework/wizard/wizard.component').then(c => c.WizardComponent)
                            }
                        ]
                    },
                    {
                        path: 'edit',
                        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/school/homework/wizard/wizard.component').then(c => c.WizardComponent)
                            }
                        ]
                    }
                ]
            },
            {
                path: 'class-session',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/school-layout/school-layout.component').then(c => c.SchoolLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/class-session/class-session.component').then(c => c.ClassSessionComponent)
                            }
                        ]
                    },
                    {
                        path: 'create',
                        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/class-session/class-session-wizard/class-session-wizard.component').then(c => c.ClassSessionWizardComponent)
                            }
                        ]
                    },
                    {
                        path: 'edit',
                        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/class-session/class-session-wizard/class-session-wizard.component').then(c => c.ClassSessionWizardComponent)
                            }
                        ]
                    },
                    {
                        path: 'teacher',
                        loadComponent: () => import('app/layouts/chat-layout/chat-layout.component').then(c => c.ChatLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/class-session/class-session-teacher/class-session-teacher.component').then(c => c.ClassSessionTeacherComponent)
                            }
                        ]
                    },
                    {
                        path: 'student',
                        loadComponent: () => import('app/layouts/chat-layout/chat-layout.component').then(c => c.ChatLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/class-session/class-session-student/class-session-student.component').then(c => c.ClassSessionStudentComponent)
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: 'family',
        canActivate: [authGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('app/layouts/app-layout/app-layout.component').then(c => c.AppLayoutComponent),
                canActivate: [authGuard],
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/modules/family/family.component').then(c => c.FamilyComponent),
                    }
                ]
            },
            {
                path: 'wizard',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('app/modules/family/family-wizard/family-wizard.component').then(c => c.FamilyWizardComponent)
                            }
                        ]
                    }
                ]
            },
            {
                path: 'activity-history',
                loadComponent: () => import('app/layouts/app-layout/app-layout.component').then(c => c.AppLayoutComponent),
                canActivate: [authGuard],
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/modules/family/activity-history/activity-history.component').then(c => c.ActivityHistoryComponent)
                    }
                ]
            },
            {
                path: 'recover-password',
                loadComponent: () => import('app/layouts/app-layout/app-layout.component').then(c => c.AppLayoutComponent),
                canActivate: [authGuard],
                children: [
                    {
                        path: '',
                        loadComponent: () => import('app/modules/family/recover-password-parent/recover-password-parent.component').then(c => c.RecoverPasswordParentComponent)
                    }
                ]
            }
        ]
    },

    // Chat
    {
        path: 'chat',
        loadComponent: () => import('app/layouts/chat-layout/chat-layout.component').then(c => c.ChatLayoutComponent),
        canActivate: [authGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('app/modules/chat/chat.component').then(c => c.ChatComponent)
            }
        ]
    },

    // auth routes
    {
        path: '',
        loadComponent: () => import('app/layouts/auth-layout/auth-layout.component').then(c => c.AuthLayoutComponent),
        children: [
            {
                path: 'sign-in',
                loadComponent: () => import('app/modules/auth/sign-in/sign-in.component').then(c => c.SignInComponent)
            },
            {
                path: 'sign-in-email',
                loadComponent: () => import('app/modules/auth/sign-in-email/sign-in-email.component').then(c => c.SignInEmailComponent)
            },
            {
                path: 'recovery-password',
                loadComponent: () => import('app/modules/auth/recovery-password/recovery-password.component').then(c => c.RecoveryPasswordComponent)
            },
            {
                path: 'register',
                loadComponent: () => import('app/modules/auth/register/register.component').then(c => c.RegisterComponent)
            },
            {
                path: 'verify-email',
                loadComponent: () => import('app/modules/auth/verify-email/verify-email.component').then(c => c.VerifyEmailComponent)
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('app/modules/auth/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent)
            },
        ]
    },

    // onborading
    {
        path: 'welcome-wizard',
        loadComponent: () => import('app/layouts/wizard-layout/wizard-layout.component').then(c => c.WizardLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('app/modules/welcome-wizard/welcome-wizard.component').then(c => c.WelcomeWizardComponent)
            }
        ]
    },


    // wake up as
    {
        path: 'wake-up-as',
        loadComponent: () => import('app/layouts/app-layout/app-layout.component').then(c => c.AppLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('app/modules/wake-up-as/wake-up-as.component').then(c => c.WakeUpAsComponent),
            }
        ],
        canActivate: [authGuard],
    },

    // Test routes
    {
        path: '',
        redirectTo: '/learn',
        //redirectTo: '/practice',
        pathMatch: 'full'  // Esto asegura que la redirección se aplique solo cuando la URL esté completamente vacía
    },
    { path: '**', redirectTo: '/', pathMatch: 'full' },
];
